import React from "react";
import SubLevelIndex from "../SubLevelIndex";

export default function Catalog(props) {
  return (
    <SubLevelIndex {...props} category="playlists" defaultRoute="manual" />
  );
}
